import { useFeatureFlag } from '@qualio/ui-components';

export const useFeatureFlagValue = (flagName: string): boolean => {
  const featureFlags = useFeatureFlag();
  return Boolean(featureFlags[flagName]);
};
